
import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import Swal from "sweetalert2";
import {
    Box,
    Typography,
    TextField,
    InputAdornment,
    IconButton,
    Button,
    CircularProgress,
    Divider,
} from "@mui/material";
import {
    SchoolRounded,
    EmailRounded,
    LockRounded,
    VisibilityRounded,
    VisibilityOffRounded,
    ArrowForwardRounded,
    ArrowBackRounded,
    VerifiedRounded,
    AutoAwesomeRounded,
    MenuBookRounded,
    WorkspacePremiumRounded,
    SecurityRounded,
    BoltRounded,
} from "@mui/icons-material";

import api from "../api/api";
import { AuthContext } from "../AuthContext";
import student from "./schoolmanagementsystem.png";

const C = {
    navy: "#07152F",
    navyLight: "#10294D",
    blue: "#087EA4",
    blueLight: "#DFF5FC",
    bluePale: "#F1FAFD",
    orange: "#F97316",
    orangePale: "#FFF0E5",
    white: "#FFFFFF",
    ink: "#12243A",
    muted: "#738296",
    border: "#E1EAF0",
    green: "#15966A",
};

const BRAND = "Salvation In Christ";

const css = `
.sicx-root {
    min-height: 100vh;
    min-height: 100dvh;
    width: 100%;
    color: ${C.ink};
    background: #f5f8fc;
    font-family: Inter, "Segoe UI", Arial, sans-serif;
    overflow: hidden;
}
.sicx-root * { box-sizing: border-box; }
.sicx-root a { text-decoration: none; }
.sicx-layout {
    display: grid;
    grid-template-columns: minmax(0, 1.06fr) minmax(440px, .94fr);
    min-height: 100vh;
    min-height: 100dvh;
}
.sicx-showcase {
    position: relative;
    isolation: isolate;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 0;
    overflow: hidden;
    padding: 35px clamp(26px, 4vw, 65px) 25px;
    color: white;
    background:
        radial-gradient(ellipse at 15% 10%, rgba(8,126,164,.35), transparent 34%),
        radial-gradient(ellipse at 88% 80%, rgba(249,115,22,.12), transparent 31%),
        linear-gradient(145deg, #07152f 0%, #071d3a 52%, #03263b 100%);
}
.sicx-showcase:before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: -1;
    opacity: .14;
    background-image: radial-gradient(rgba(255,255,255,.5) .7px, transparent .7px);
    background-size: 21px 21px;
    mask-image: linear-gradient(140deg, black, transparent 76%);
}
.sicx-showcase:after {
    content: "";
    position: absolute;
    width: 520px;
    height: 520px;
    right: -330px;
    top: 17%;
    border: 1px solid rgba(255,255,255,.1);
    border-radius: 50%;
    box-shadow: 0 0 0 45px rgba(255,255,255,.025), 0 0 0 90px rgba(255,255,255,.02);
    pointer-events: none;
}
.sicx-brand {
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
    z-index: 3;
}
.sicx-brand-mark {
    width: 48px;
    height: 48px;
    flex: 0 0 48px;
    display: grid;
    place-items: center;
    border: 1px solid rgba(255,255,255,.23);
    border-radius: 16px;
    background: linear-gradient(145deg, #159bc1, #056083);
    box-shadow: 0 9px 25px rgba(0,0,0,.22);
}
.sicx-brand-title {
    color: #fff;
    font-size: 13px;
    font-weight: 900;
    letter-spacing: .7px;
    line-height: 1.5;
}
.sicx-brand-subtitle {
    color: #ffdd00;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 2px;
}
.sicx-hero {
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 680px;
    margin: 38px auto 28px;
}
.sicx-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border: 1px solid rgba(255,255,255,.17);
    border-radius: 50px;
    background: rgba(255,255,255,.065);
    color: #c6effa;
    font-size: 10px;
    font-weight: 850;
    letter-spacing: 1.6px;
}
.sicx-hero-heading {
    margin: 22px 0 0 !important;
    max-width: 640px;
    // color: #ffae00;
    color: #8B5CF6;
    font-size: clamp(37px, 4.3vw, 65px) !important;
    font-weight: 950 !important;
    letter-spacing: -2.5px !important;
    line-height: 1.04 !important;
}
.sicx-hero-heading span {
    // color: #7de1f6;
     color: #fcbb30;
}
.sicx-hero-description {
    max-width: 470px;
    margin-top: 18px !important;
    color: #b7c9dd;
    font-size: 14px !important;
    line-height: 1.9 !important;
}
.sicx-visual {
    position: relative;
    min-height: 250px;
    height: clamp(250px, 35vh, 390px);
    margin-top: 12px;
}
.sicx-visual-halo {
    position: absolute;
    left: 50%;
    top: 50%;
    width: min(85%, 410px);
    aspect-ratio: 1;
    transform: translate(-50%, -48%);
    border-radius: 50%;
    background: radial-gradient(circle, rgba(14,130,173,.32), rgba(8,39,70,.2) 54%, transparent 72%);
    border: 1px solid rgba(125,225,246,.13);
    box-shadow: 0 0 0 28px rgba(255,255,255,.018), 0 0 0 62px rgba(255,255,255,.012);
}
.sicx-student {
    position: absolute;
    z-index: 2;
    width: min(83%, 470px);
    height: 100%;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    object-fit: contain;
    object-position: center bottom;
    filter: drop-shadow(0 25px 24px rgba(0,0,0,.25));
}
.sicx-floating {
    position: absolute;
    z-index: 4;
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 12px 15px;
    border: 1px solid rgba(255,255,255,.19);
    border-radius: 15px;
    color: #fff;
    background: rgba(11,34,61,.78);
    backdrop-filter: blur(14px);
    box-shadow: 0 15px 40px rgba(0,0,0,.17);
}
.sicx-floating-icon {
    width: 36px;
    height: 36px;
    display: grid;
    place-items: center;
    border-radius: 11px;
    color: #9de9fa;
    background: rgba(8,126,164,.2);
}
.sicx-floating-label {
    color: #a9bdcf;
    font-size: 10px;
    font-weight: 700;
}
.sicx-floating-value {
    margin-top: 3px;
    color: white;
    font-size: 12px;
    font-weight: 850;
}
.sicx-float-left { left: 0; top: 17%; }
.sicx-float-right { right: 0; bottom: 14%; }
.sicx-showcase-footer {
    position: relative;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    padding-top: 18px;
    border-top: 1px solid rgba(255,255,255,.13);
}
.sicx-footer-text {
    color: #a6b8ca;
    font-size: 10px;
    line-height: 1.7;
}
.sicx-footer-highlight {
    color: #f4a36e;
    font-weight: 850;
}
.sicx-form-side {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-width: 0;
    min-height: 100vh;
    padding: 35px clamp(24px, 4vw, 68px);
    overflow: hidden;
    background:
        radial-gradient(ellipse at 100% 0%, rgba(8,126,164,.08), transparent 34%),
        linear-gradient(155deg, #fbfdff 0%, #f4f8fc 100%);
}
.sicx-form-side:before {
    content: "";
    position: absolute;
    width: 290px;
    height: 290px;
    left: -210px;
    bottom: -160px;
    border: 1px solid rgba(8,126,164,.11);
    border-radius: 50%;
    box-shadow: 0 0 0 32px rgba(8,126,164,.025), 0 0 0 65px rgba(8,126,164,.02);
    pointer-events: none;
}
.sicx-form-inner {
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 425px;
    margin: auto;
}
.sicx-form-topline {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 31px;
}
.sicx-portal-label {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    color: #52677d;
    font-size: 10px;
    font-weight: 900;
    letter-spacing: 1.2px;
}
.sicx-online {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #15815f;
    font-size: 10px;
    font-weight: 800;
}
.sicx-online-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #1ab27c;
    box-shadow: 0 0 0 4px rgba(26,178,124,.1);
}
.sicx-form-heading {
    margin: 0 !important;
    color: ${C.navy};
    font-size: clamp(30px, 3vw, 39px) !important;
    font-weight: 950 !important;
    letter-spacing: -1.4px !important;
    line-height: 1.16 !important;
}
.sicx-form-description {
    margin-top: 11px !important;
    color: #748499;
    font-size: 13px !important;
    line-height: 1.8 !important;
}
.sicx-field {
    margin-top: 22px !important;
}
.sicx-field .MuiInputLabel-root {
    color: #718197;
    font-size: 13px;
    font-weight: 600;
}
.sicx-field .MuiOutlinedInput-root {
    min-height: 56px;
    border-radius: 13px;
    background: rgba(255,255,255,.91);
    color: #16283d;
    font-size: 13px;
    transition: box-shadow .2s ease, background .2s ease;
}
.sicx-field .MuiOutlinedInput-notchedOutline {
    border-color: #dce6ee;
}
.sicx-field .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: #9acddd;
}
.sicx-field .MuiOutlinedInput-root.Mui-focused {
    background: #fff;
    box-shadow: 0 0 0 4px rgba(8,126,164,.075);
}
.sicx-field .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #087ea4;
    border-width: 1.5px;
}
.sicx-field .MuiInputLabel-root.Mui-focused {
    color: #087ea4;
}
.sicx-submit {
    min-height: 55px !important;
    border-radius: 13px !important;
    color: white !important;
    background: linear-gradient(105deg, #071b3e 0%, #075e81 70%, #087ea4 100%) !important;
    font-size: 13px !important;
    font-weight: 900 !important;
    text-transform: none !important;
    box-shadow: 0 12px 25px rgba(7,76,112,.18) !important;
    transition: transform .2s ease, box-shadow .2s ease !important;
}
.sicx-submit:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 30px rgba(7,76,112,.24) !important;
}
.sicx-submit:disabled {
    color: white !important;
    background: #8aa6b5 !important;
    box-shadow: none !important;
}
.sicx-home-button {
    color: #66788d !important;
    font-size: 12px !important;
    font-weight: 750 !important;
    text-transform: none !important;
}
.sicx-home-button:hover { background: rgba(8,126,164,.06) !important; }
.sicx-trust-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px;
    border: 1px solid #e0ebf1;
    border-radius: 13px;
    background: rgba(255,255,255,.7);
}
.sicx-trust-icon {
    width: 38px;
    height: 38px;
    flex: 0 0 38px;
    display: grid;
    place-items: center;
    border-radius: 11px;
    color: #087ea4;
    background: #e4f7fc;
}
.sicx-trust-title {
    color: #21374b;
    font-size: 11px;
    font-weight: 850;
}
.sicx-trust-copy {
    margin-top: 3px;
    color: #8290a0;
    font-size: 10px;
    line-height: 1.6;
}
.sicx-mobile-brand { display: none; }

@media (max-width: 1050px) {
    .sicx-layout { grid-template-columns: minmax(0, 1fr) minmax(390px, .95fr); }
    .sicx-showcase { padding-left: 30px; padding-right: 30px; }
    .sicx-hero-heading { font-size: clamp(36px, 4.5vw, 52px) !important; }
    .sicx-floating { padding: 10px; }
    .sicx-float-left { left: -5px; }
    .sicx-float-right { right: -5px; }
}
@media (max-width: 800px) {
    .sicx-root { overflow: auto; }
    .sicx-layout { display: block; min-height: 100vh; min-height: 100dvh; }
    .sicx-showcase { display: none; }
    .sicx-mobile-brand {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 16px 19px;
        color: white;
        background: linear-gradient(115deg, #07152f, #073755);
    }
    .sicx-mobile-brand .sicx-brand-mark { width: 42px; height: 42px; flex-basis: 42px; }
    .sicx-mobile-portal {
        padding: 7px 10px;
        border: 1px solid rgba(255,255,255,.2);
        border-radius: 30px;
        color: #c5eefa;
        font-size: 9px;
        font-weight: 850;
        letter-spacing: .6px;
        white-space: nowrap;
    }
    .sicx-form-side {
        min-height: auto;
        padding: 31px 21px 24px;
        overflow: visible;
        background: linear-gradient(180deg, #f1f8fc 0%, #fbfdff 100%);
    }
    .sicx-form-inner { max-width: 470px; }
    .sicx-form-topline { margin-bottom: 25px; }
    .sicx-form-heading { font-size: 34px !important; }
}
@media (max-width: 420px) {
    .sicx-mobile-brand { padding: 13px 12px; }
    .sicx-brand-title { font-size: 11px; }
    .sicx-brand-subtitle { font-size: 9px; letter-spacing: 1.4px; }
    .sicx-mobile-portal { font-size: 8px; padding: 7px 8px; }
    .sicx-form-side { padding: 25px 15px 22px; }
    .sicx-form-heading { font-size: 30px !important; }
    .sicx-form-topline { margin-bottom: 23px; }
}
@media (prefers-reduced-motion: reduce) {
    .sicx-root *, .sicx-root *::before, .sicx-root *::after {
        animation-duration: .01ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: .01ms !important;
        scroll-behavior: auto !important;
    }
}
`;

const Login = () => {
    const navigate = useNavigate();
    const { setUser } = useContext(AuthContext);
    const reduceMotion = useReducedMotion();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const clearAuthenticationData = () => {
        [
            "access",
            "refresh",
            "user",
            "employment_status",
            "employment_status_display",
            "employment_academic_year",
            "auth_email",
        ].forEach((key) => localStorage.removeItem(key));
    };

    const redirectUser = (user) => {
        const role = String(user?.user_type || user?.role || "")
            .toLowerCase()
            .trim();

        const routes = {
            owner: "/owner-dashboard",
            admin: "/newAdminDashboard",
            teacher: "/teacher-dashboard",
            student: "/student-dashboard",
            parent: "/parentsDashboard",
            registry: "/registerDashboard",
            principal: "/principal-dashboard",
            proprietor: "/proprietor-dashboard",
            vpi: "/vpi-dashboard",
            vpa: "/newVpaDashboard",
            "it personel": "/it-dashboard",
            "it personnel": "/it-dashboard",
            business_manager: "/businessManagerDashboard",
            "business manager": "/businessManagerDashboard",
            "admission officer": "/admissionOfficialDashboard",
            admission_officer: "/admissionOfficialDashboard",
            dean: "/dean-dashboard",
        };

        navigate(routes[role] || "/");
    };

    const showEmploymentStatusAlert = (data) => {
        const code = String(data?.error_code || "").toUpperCase().trim();
        const status = String(data?.employment_status || "").toLowerCase().trim();
        const year = String(
            data?.academic_year ||
            data?.academic_year_name ||
            "the current academic year"
        );

        const fire = (options) =>
            Swal.fire({
                confirmButtonColor: C.orange,
                background: "#fff",
                ...options,
            });

        if (
            ["TEACHER_FIRED", "EMPLOYMENT_FIRED"].includes(code) ||
            status === "fired"
        ) {
            return fire({
                icon: "error",
                title: "Account Access Restricted",
                text: "Your employment record indicates that your employment has been terminated. Please contact the school administration for assistance.",
            });
        }

        if (
            ["TEACHER_REMOVED", "EMPLOYMENT_REMOVED"].includes(code) ||
            status === "removed"
        ) {
            return fire({
                icon: "warning",
                title: "Account Access Restricted",
                text: "Your employment record indicates that you have been removed from the school. Please contact the school administration for assistance.",
            });
        }

        if (code === "TEACHER_NOT_ASSIGNED") {
            return fire({
                icon: "warning",
                title: "Teacher Not Assigned",
                text: `Your teacher account is not assigned to an active academic year. Academic year: ${year}. Please contact the school administration.`,
            });
        }

        if (code === "NO_ACTIVE_ACADEMIC_YEAR") {
            return fire({
                icon: "warning",
                title: "No Active Academic Year",
                text: "There is currently no active academic year. Please contact the school administration.",
            });
        }

        if (
            ["EMPLOYMENT_LOGIN_BLOCKED", "LOGIN_BLOCKED"].includes(code)
        ) {
            return fire({
                icon: "warning",
                title: "Login Blocked",
                text: "Your account is currently blocked from accessing the school management system. Please contact an authorized administrator.",
            });
        }

        return Promise.resolve();
    };

    const handleBlockedResponse = (data) => {
        if (!data) return false;

        const status = String(data?.employment_status || "").toLowerCase().trim();
        const code = String(data?.error_code || "").toUpperCase().trim();

        const codes = [
            "TEACHER_REMOVED",
            "TEACHER_FIRED",
            "EMPLOYMENT_REMOVED",
            "EMPLOYMENT_FIRED",
            "EMPLOYMENT_LOGIN_BLOCKED",
            "LOGIN_BLOCKED",
            "TEACHER_NOT_ASSIGNED",
            "NO_ACTIVE_ACADEMIC_YEAR",
        ];

        if (
            !codes.includes(code) &&
            !["removed", "fired"].includes(status)
        ) {
            return false;
        }

        clearAuthenticationData();
        showEmploymentStatusAlert(data);
        return true;
    };

    const getLoginError = (error) => {
        const data = error?.response?.data;

        if (data?.detail) return String(data.detail);
        if (data?.message) return String(data.message);
        if (typeof data === "string") return data;

        if (data && typeof data === "object") {
            const messages = [];

            Object.entries(data).forEach(([key, value]) => {
                if (key === "detail") return;

                if (Array.isArray(value)) {
                    value.forEach((item) => messages.push(String(item)));
                } else if (typeof value === "string") {
                    messages.push(value);
                }
            });

            if (messages.length) return messages.join("\n");
        }

        return "Invalid email or password. Please check your details and try again.";
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const cleanEmail = email.trim();

        if (!cleanEmail || !password) {
            await Swal.fire({
                icon: "warning",
                title: "Complete Your Login",
                text: "Please enter your email address and password.",
                confirmButtonColor: C.orange,
            });
            return;
        }

        setLoading(true);

        try {
            clearAuthenticationData();

            const response = await api.post("/api/token/", {
                email: cleanEmail,
                password,
            });

            if (handleBlockedResponse(response.data)) return;

            const role = String(
                response.data?.user_type ||
                response.data?.user?.role ||
                ""
            ).toLowerCase().trim();

            const authenticationRoles = [
                "admin",
                "registry",
                "principal",
                "proprietor",
                "business_manager",
                "business manager",
                "vpi",
                "vpa",
                "it personel",
                "it personnel",
            ];

            if (
                response.data?.requires_authentication &&
                authenticationRoles.includes(role)
            ) {
                const authEmail =
                    response.data?.email ||
                    response.data?.user?.email ||
                    cleanEmail;

                localStorage.setItem("auth_email", authEmail);

                navigate("/loginAuthentication", {
                    state: { email: authEmail },
                });
                return;
            }

            const { access, refresh } = response.data || {};

            if (!access || !refresh) {
                throw new Error("Authentication tokens were not returned.");
            }

            localStorage.setItem("access", access);
            localStorage.setItem("refresh", refresh);

            if (response.data?.employment_status) {
                localStorage.setItem(
                    "employment_status",
                    response.data.employment_status
                );
            }

            if (response.data?.employment_status_display) {
                localStorage.setItem(
                    "employment_status_display",
                    response.data.employment_status_display
                );
            }

            if (response.data?.academic_year) {
                localStorage.setItem(
                    "employment_academic_year",
                    response.data.academic_year
                );
            }

            window.dispatchEvent(new Event("user-logged-in"));

            let profileResponse;

            try {
                profileResponse = await api.get("/api/user-profile/");
            } catch (profileError) {
                clearAuthenticationData();
                throw profileError;
            }

            const user = profileResponse.data;

            const employmentStatus = String(
                response.data?.employment_status ||
                user?.employment_status ||
                ""
            ).toLowerCase().trim();

            if (["removed", "fired"].includes(employmentStatus)) {
                clearAuthenticationData();

                await showEmploymentStatusAlert({
                    error_code:
                        employmentStatus === "removed"
                            ? "TEACHER_REMOVED"
                            : "TEACHER_FIRED",
                    employment_status: employmentStatus,
                });

                return;
            }

            setUser(user);
            localStorage.setItem("user", JSON.stringify(user));

            await Swal.fire({
                icon: "success",
                title: "Welcome Back!",
                text: `Welcome ${user?.user_type || user?.role || ""}`,
                timer: 1600,
                showConfirmButton: false,
                background: "#fff",
                iconColor: C.green,
            });

            redirectUser(user);
        } catch (error) {
            console.error("LOGIN ERROR:", error);

            if (handleBlockedResponse(error?.response?.data)) return;

            await Swal.fire({
                icon: "error",
                title: "Unable to Sign In",
                text: getLoginError(error),
                confirmButtonText: "Try Again",
                confirmButtonColor: C.orange,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box className="sicx-root">
            <style>{css}</style>

            <Box className="sicx-layout">
                {/* DESKTOP BRAND EXPERIENCE */}
                <Box className="sicx-showcase">
                    <Box className="sicx-brand">
                        <Box className="sicx-brand-mark">
                            <SchoolRounded sx={{ fontSize: 28 }} />
                        </Box>

                        <Box>
                            <Typography className="sicx-brand-title">
                                Salvation In Christ
                            </Typography>
                            <Typography className="sicx-brand-subtitle">
                               SICSS - SCHOOL SYSTEM
                            </Typography>
                        </Box>
                    </Box>

                    <Box className="sicx-hero">
                        <motion.div
                            initial={reduceMotion ? false : { opacity: 0, y: 12 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.55 }}
                        >
                            <Box className="sicx-eyebrow">
                                <AutoAwesomeRounded sx={{ fontSize: 15, color: C.orange }} />
                                EDUCATION WITH PURPOSE
                            </Box>

                            <Typography className="sicx-hero-heading">
                                Equipping For  
                                <br />
                                A <span>Better Future.</span>
                            </Typography>

                            <Typography className="sicx-hero-description">
                                A connected school community where learning,
                                character, and excellence prepare every student
                                for a brighter tomorrow.
                            </Typography>
                        </motion.div>

                        <Box className="sicx-visual">
                            <Box className="sicx-visual-halo" />

                            <motion.img
                                src={student}
                                alt="Student representing academic achievement"
                                className="sicx-student"
                                initial={reduceMotion ? false : { opacity: 0, y: 18 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.75, delay: 0.12 }}
                            />

                            <motion.div
                                className="sicx-floating sicx-float-left"
                                animate={reduceMotion ? {} : { y: [0, -7, 0] }}
                                transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
                            >
                                <Box className="sicx-floating-icon">
                                    <MenuBookRounded />
                                </Box>
                                <Box>
                                    <Typography className="sicx-floating-label">
                                        YOUR JOURNEY
                                    </Typography>
                                    <Typography className="sicx-floating-value">
                                        Starts with learning
                                    </Typography>
                                </Box>
                            </motion.div>

                            <motion.div
                                className="sicx-floating sicx-float-right"
                                animate={reduceMotion ? {} : { y: [0, 7, 0] }}
                                transition={{ duration: 4.5, repeat: Infinity, ease: "easeInOut" }}
                            >
                                <Box
                                    className="sicx-floating-icon"
                                    sx={{
                                        color: "#ffd2b3",
                                        background: "rgba(249,115,22,.18)",
                                    }}
                                >
                                    <WorkspacePremiumRounded sx={{ color: "#ffb37f" }} />
                                </Box>
                                <Box>
                                    <Typography className="sicx-floating-label">
                                        OUR COMMITMENT
                                    </Typography>
                                    <Typography className="sicx-floating-value">
                                        Character & excellence
                                    </Typography>
                                </Box>
                            </motion.div>
                        </Box>
                    </Box>

                    <Box className="sicx-showcase-footer">
                        <Box>
                            <Typography className="sicx-footer-text">
                                LEARNING <span className="sicx-footer-highlight">•</span>{" "}
                                CHARACTER <span className="sicx-footer-highlight">•</span>{" "}
                                EXCELLENCE
                            </Typography>
                            <Typography className="sicx-footer-text">
                                Empowering the next generation through education.
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.7,
                                color: "#b9dce9",
                                fontSize: 10,
                                fontWeight: 800,
                                whiteSpace: "nowrap",
                            }}
                        >
                            <BoltRounded sx={{ color: C.orange, fontSize: 17 }} />
                            POWERED BY POLU
                        </Box>
                    </Box>
                </Box>

                {/* MOBILE HEADER */}
                <Box className="sicx-mobile-brand">
                    <Box className="sicx-brand">
                        <Box className="sicx-brand-mark">
                            <SchoolRounded sx={{ fontSize: 25 }} />
                        </Box>

                        <Box>
                            <Typography className="sicx-brand-title">
                                Salvation In Christ
                            </Typography>
                            <Typography className="sicx-brand-subtitle">
                                SCHOOL SYSTEM
                            </Typography>
                        </Box>
                    </Box>

                    <Box className="sicx-mobile-portal">
                        POLU PORTAL
                    </Box>
                </Box>

                {/* LOGIN EXPERIENCE */}
                <Box className="sicx-form-side">
                    <motion.div
                        className="sicx-form-inner"
                        initial={reduceMotion ? false : { opacity: 0, x: 15 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.45, ease: "easeOut" }}
                    >
                        <Box className="sicx-form-topline">
                            <Box className="sicx-portal-label">
                                <SecurityRounded sx={{ fontSize: 17, color: C.blue }} />
                                SECURE PORTAL
                            </Box>

                            <Box className="sicx-online">
                                <Box className="sicx-online-dot" />
                                SYSTEM ACCESS
                            </Box>
                        </Box>

                        <Typography component="h1" className="sicx-form-heading">
                            Welcome back<span style={{ color: C.orange }}>.</span>
                        </Typography>

                        <Typography className="sicx-form-description">
                            Sign in with your registered school account to
                            continue to your personalized dashboard.
                        </Typography>

                        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3.2 }}>
                            <Typography
                                sx={{
                                    mb: 0.8,
                                    color: "#34485e",
                                    fontSize: 12,
                                    fontWeight: 850,
                                }}
                            >
                                Email address
                            </Typography>

                            <TextField
                                className="sicx-field"
                                fullWidth
                                placeholder="you@example.com"
                                type="email"
                                value={email}
                                onChange={(event) => setEmail(event.target.value)}
                                required
                                autoComplete="username"
                                autoCapitalize="none"
                                autoCorrect="off"
                                inputProps={{ spellCheck: false }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <EmailRounded
                                                sx={{ color: "#8ba0b2", fontSize: 20 }}
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{ mt: "0 !important" }}
                            />

                            <Box
                                sx={{
                                    mt: 2.5,
                                    mb: 0.8,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: 1,
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#34485e",
                                        fontSize: 12,
                                        fontWeight: 850,
                                    }}
                                >
                                    Password
                                </Typography>

                                <Link
                                    to="/forgotPassword"
                                    style={{
                                        color: C.blue,
                                        fontSize: 11,
                                        fontWeight: 850,
                                    }}
                                >
                                    Forgot password?
                                </Link>
                            </Box>

                            <TextField
                                className="sicx-field"
                                fullWidth
                                placeholder="Enter your password"
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(event) => setPassword(event.target.value)}
                                required
                                autoComplete="current-password"
                                sx={{ mt: "0 !important" }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <LockRounded
                                                sx={{ color: "#8ba0b2", fontSize: 20 }}
                                            />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() =>
                                                    setShowPassword((previous) => !previous)
                                                }
                                                edge="end"
                                                aria-label={
                                                    showPassword
                                                        ? "Hide password"
                                                        : "Show password"
                                                }
                                            >
                                                {showPassword ? (
                                                    <VisibilityOffRounded
                                                        sx={{ color: "#8192a4", fontSize: 20 }}
                                                    />
                                                ) : (
                                                    <VisibilityRounded
                                                        sx={{ color: "#8192a4", fontSize: 20 }}
                                                    />
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />

                            <Button
                                className="sicx-submit"
                                type="submit"
                                fullWidth
                                disabled={loading}
                                sx={{ mt: 3.2 }}
                                endIcon={
                                    !loading ? (
                                        <ArrowForwardRounded />
                                    ) : null
                                }
                            >
                                {loading ? (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1.2,
                                        }}
                                    >
                                        <CircularProgress
                                            size={19}
                                            thickness={5}
                                            sx={{ color: "#fff" }}
                                        />
                                        Authenticating...
                                    </Box>
                                ) : (
                                    "Sign in to your account"
                                )}
                            </Button>

                            <Button
                                className="sicx-home-button"
                                fullWidth
                                onClick={() => navigate("/")}
                                startIcon={<ArrowBackRounded sx={{ fontSize: 17 }} />}
                                sx={{ mt: 1.3, py: 1.1 }}
                            >
                                Return to school homepage
                            </Button>
                        </Box>

                        <Divider sx={{ my: 2.8, borderColor: "#e5edf2" }} />

                        <Box className="sicx-trust-row">
                            <Box className="sicx-trust-icon">
                                <VerifiedRounded sx={{ fontSize: 21 }} />
                            </Box>

                            <Box sx={{ minWidth: 0 }}>
                                <Typography className="sicx-trust-title">
                                    Your account, protected.
                                </Typography>
                                <Typography className="sicx-trust-copy">
                                    Sign in using your registered credentials.
                                    Never share your password with anyone.
                                </Typography>
                            </Box>
                        </Box>

                        <Typography
                            sx={{
                                mt: 3,
                                color: "#98a5b3",
                                fontSize: 10,
                                lineHeight: 1.8,
                                textAlign: "center",
                            }}
                        >
                            © {new Date().getFullYear()} {BRAND}
                            <br />
                            School Management Portal · Powered by POLU
                        </Typography>
                    </motion.div>
                </Box>
            </Box>
        </Box>
    );
};

export default Login;







// import React, { useContext, useState } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import Swal from "sweetalert2";
// import { motion } from "framer-motion";

// import {
//     Box,
//     Typography,
//     Paper,
//     TextField,
//     InputAdornment,
//     IconButton,
//     Button,
//     CircularProgress,
//     useMediaQuery,
// } from "@mui/material";

// import {
//     School,
//     Email,
//     Lock,
//     Visibility,
//     VisibilityOff,
//     ArrowBack,
//     Security,
//     AutoAwesome,
//     Bolt,
//     VerifiedUser,
// } from "@mui/icons-material";

// import api from "../api/api";
// import { AuthContext } from "../AuthContext";

// import student from "./schoolmanagementsystem.png";

// const COLORS = {
//     skyBlue: "#EAF8FF",
//     lightBlue: "#DDF3FF",
//     softBlue: "#C7ECFF",
//     oceanBlue: "#087EA4",
//     deepOcean: "#045A78",
//     deepBlue: "#031B4E",
//     navy: "#020617",
//     black: "#101820",
//     white: "#FFFFFF",
//     orange: "#F97316",
//     deepOrange: "#D94801",
//     softOrange: "#FFF1E8",
//     text: "#102A36",
//     muted: "#607D8B",
//     border: "#D7EAF2",
// };

// const EnergyParticle = ({
//     top,
//     left,
//     right,
//     bottom,
//     size = 7,
//     delay = 0,
//     color = COLORS.white,
// }) => (
//     <motion.div
//         initial={{
//             opacity: 0,
//             scale: 0.2,
//         }}
//         animate={{
//             opacity: [0, 1, 0.7, 0],
//             scale: [0.2, 1, 1.25, 0.1],
//             x: [0, -10, 12, -20],
//             y: [0, -12, -26, -42],
//         }}
//         transition={{
//             duration: 3.5,
//             delay,
//             repeat: Infinity,
//             ease: "easeOut",
//         }}
//         style={{
//             position: "absolute",
//             top,
//             left,
//             right,
//             bottom,
//             width: size,
//             height: size,
//             borderRadius: "50%",
//             background: color,
//             boxShadow: `0 0 18px ${color}`,
//             zIndex: 12,
//         }}
//     />
// );

// const SpeedLine = ({
//     top,
//     left,
//     right,
//     width = 120,
//     rotate = -20,
//     delay = 0,
//     color = COLORS.white,
// }) => (
//     <motion.div
//         initial={{
//             opacity: 0,
//             x: 0,
//             scaleX: 0.3,
//         }}
//         animate={{
//             opacity: [0, 0.9, 0],
//             x: [0, 35, 75],
//             scaleX: [0.3, 1, 0.5],
//         }}
//         transition={{
//             duration: 2.2,
//             delay,
//             repeat: Infinity,
//             ease: "easeOut",
//         }}
//         style={{
//             position: "absolute",
//             top,
//             left,
//             right,
//             width,
//             height: 5,
//             borderRadius: 20,
//             background: `linear-gradient(90deg, transparent, ${color})`,
//             transform: `rotate(${rotate}deg)`,
//             transformOrigin: "left center",
//             zIndex: 8,
//         }}
//     />
// );

// const OrbitEnergy = ({
//     size,
//     duration,
//     reverse = false,
//     color,
//     secondaryColor,
//     delay = 0,
//     dashed = false,
// }) => (
//     <motion.div
//         animate={{
//             rotate: reverse ? -360 : 360,
//         }}
//         transition={{
//             duration,
//             delay,
//             repeat: Infinity,
//             ease: "linear",
//         }}
//         style={{
//             position: "absolute",
//             width: size,
//             height: size,
//             borderRadius: "50%",
//             border: dashed
//                 ? `2px dashed ${color}`
//                 : `2px solid ${color}`,
//             borderTopColor: secondaryColor || color,
//             borderRightColor: secondaryColor || color,
//             zIndex: 7,
//             pointerEvents: "none",
//         }}
//     >
//         <motion.div
//             animate={{
//                 scale: [0.75, 1.25, 0.75],
//                 opacity: [0.55, 1, 0.55],
//             }}
//             transition={{
//                 duration: 1.5,
//                 repeat: Infinity,
//                 ease: "easeInOut",
//             }}
//             style={{
//                 position: "absolute",
//                 top: -7,
//                 left: "50%",
//                 transform: "translateX(-50%)",
//                 width: 13,
//                 height: 13,
//                 borderRadius: "50%",
//                 background: secondaryColor || color,
//                 boxShadow: `0 0 20px ${secondaryColor || color}`,
//             }}
//         />

//         <Box
//             sx={{
//                 position: "absolute",
//                 right: -6,
//                 top: "50%",
//                 width: 10,
//                 height: 10,
//                 borderRadius: "50%",
//                 background: color,
//                 boxShadow: `0 0 16px ${color}`,
//                 transform: "translateY(-50%)",
//             }}
//         />

//         <Box
//             sx={{
//                 position: "absolute",
//                 bottom: -5,
//                 left: "20%",
//                 width: 8,
//                 height: 8,
//                 borderRadius: "50%",
//                 background: secondaryColor || color,
//                 boxShadow: `0 0 15px ${secondaryColor || color}`,
//             }}
//         />
//     </motion.div>
// );

// const Login = () => {
//     const navigate = useNavigate();
//     const { setUser } = useContext(AuthContext);

//     const isMobile = useMediaQuery("(max-width:900px)");

//     const [email, setEmail] = useState("");
//     const [password, setPassword] = useState("");
//     const [loading, setLoading] = useState(false);
//     const [showPassword, setShowPassword] = useState(false);

//     const redirectUser = (user) => {
//         const role = String(
//             user?.user_type || user?.role || ""
//         )
//             .toLowerCase()
//             .trim();

//         switch (role) {
//             case "owner":
//                 navigate("/owner-dashboard");
//                 break;

//             case "admin":
//                 navigate("/newAdminDashboard");
//                 break;

//             case "teacher":
//                 navigate("/teacher-dashboard");
//                 break;

//             case "student":
//                 navigate("/student-dashboard");
//                 break;

//             case "parent":
//                 navigate("/parentsDashboard");
//                 break;

//             case "registry":
//                 navigate("/registerDashboard");
//                 break;

//             case "principal":
//                 navigate("/principal-dashboard");
//                 break;

//             case "proprietor":
//                 navigate("/proprietor-dashboard");
//                 break;

//             case "vpi":
//                 navigate("/vpi-dashboard");
//                 break;

//             case "vpa":
//                 navigate("/newVpaDashboard");
//                 break;

//             case "it personel":
//             case "it personnel":
//                 navigate("/it-dashboard");
//                 break;

//             case "business_manager":
//             case "business manager":
//                 navigate("/businessManagerDashboard");
//                 break;

//             case "admission officer":
//             case "admission_officer":
//                 navigate("/admissionOfficialDashboard");
//                 break;

//             case "dean":
//                 navigate("/dean-dashboard");
//                 break;

//             default:
//                 navigate("/");
//         }
//     };

//     const clearAuthenticationData = () => {
//         localStorage.removeItem("access");
//         localStorage.removeItem("refresh");
//         localStorage.removeItem("user");
//         localStorage.removeItem("employment_status");
//         localStorage.removeItem("employment_status_display");
//         localStorage.removeItem("employment_academic_year");
//         localStorage.removeItem("auth_email");
//     };

//     const getLoginError = (error) => {
//         const responseData = error?.response?.data;

//         if (responseData?.detail) {
//             return String(responseData.detail);
//         }

//         if (responseData?.message) {
//             return String(responseData.message);
//         }

//         if (typeof responseData === "string") {
//             return responseData;
//         }

//         if (
//             responseData &&
//             typeof responseData === "object"
//         ) {
//             const messages = [];

//             Object.entries(responseData).forEach(
//                 ([field, value]) => {
//                     if (field === "detail") {
//                         return;
//                     }

//                     if (Array.isArray(value)) {
//                         value.forEach((item) => {
//                             if (
//                                 item !== null &&
//                                 item !== undefined
//                             ) {
//                                 messages.push(String(item));
//                             }
//                         });
//                     } else if (
//                         typeof value === "string"
//                     ) {
//                         messages.push(value);
//                     }
//                 }
//             );

//             if (messages.length) {
//                 return messages.join("\n");
//             }
//         }

//         return "Invalid email or password.";
//     };

//     const showEmploymentStatusAlert = (data) => {
//         const errorCode = String(
//             data?.error_code || ""
//         )
//             .toUpperCase()
//             .trim();

//         const status = String(
//             data?.employment_status || ""
//         )
//             .toLowerCase()
//             .trim();

//         const academicYear =
//             data?.academic_year ||
//             data?.academic_year_name ||
//             "the current academic year";

//         const statusDisplay =
//             data?.employment_status_display ||
//             (status === "fired"
//                 ? "SACKED / FIRED"
//                 : status === "removed"
//                     ? "REMOVED"
//                     : "");

//         if (
//             errorCode === "TEACHER_FIRED" ||
//             errorCode === "EMPLOYMENT_FIRED" ||
//             status === "fired"
//         ) {
//             Swal.fire({
//                 icon: "error",
//                 title: "Account Blocked!",
//                 html: `
//                     <div style="text-align:center;">
//                         <p style="font-size:16px;line-height:1.6;">
//                             Your account cannot be used to access
//                             the school system.
//                         </p>

//                         <div style="
//                             display:inline-block;
//                             padding:8px 16px;
//                             border-radius:20px;
//                             background:#FEF2F2;
//                             color:#B91C1C;
//                             font-weight:800;
//                             margin:10px 0 14px;
//                         ">
//                             EMPLOYMENT STATUS:
//                             ${statusDisplay || "SACKED / FIRED"}
//                         </div>

//                         <p style="
//                             color:#6B7280;
//                             line-height:1.6;
//                         ">
//                             Your most recent employment record
//                             indicates that your employment was
//                             terminated.
//                         </p>

//                         <p style="
//                             color:#374151;
//                             font-weight:600;
//                             line-height:1.6;
//                         ">
//                             Please contact an authorized school
//                             administrator for assistance.
//                         </p>

//                         <p style="
//                             color:#6B7280;
//                             font-size:13px;
//                             margin-top:12px;
//                         ">
//                             Latest employment record:
//                             <strong>${academicYear}</strong>
//                         </p>
//                     </div>
//                 `,
//                 confirmButtonText: "Understood",
//                 confirmButtonColor: COLORS.orange,
//             });

//             return true;
//         }

//         if (
//             errorCode === "TEACHER_REMOVED" ||
//             errorCode === "EMPLOYMENT_REMOVED" ||
//             status === "removed"
//         ) {
//             Swal.fire({
//                 icon: "warning",
//                 title: "Account Blocked !",
//                 html: `
//                     <div style="text-align:center;">
//                         <p style="font-size:16px;line-height:1.6;">
//                             Your account cannot be used to access
//                             the school system.
//                         </p>

//                         <div style="
//                             display:inline-block;
//                             padding:8px 16px;
//                             border-radius:20px;
//                             background:#FFF7ED;
//                             color:#C2410C;
//                             font-weight:800;
//                             margin:10px 0 14px;
//                         ">
//                             EMPLOYMENT STATUS:
//                             ${statusDisplay || "REMOVED"}
//                         </div>

//                         <p style="
//                             color:#6B7280;
//                             line-height:1.6;
//                         ">
//                             Your most recent employment record
//                             indicates that you have been removed
//                             from the school.
//                         </p>

//                         <p style="
//                             color:#374151;
//                             font-weight:600;
//                             line-height:1.6;
//                         ">
//                             Please contact an authorized school
//                             administrator for assistance.
//                         </p>

//                         <p style="
//                             color:#6B7280;
//                             font-size:13px;
//                             margin-top:12px;
//                         ">
//                             Latest employment record:
//                             <strong>${academicYear}</strong>
//                         </p>
//                     </div>
//                 `,
//                 confirmButtonText: "Understood",
//                 confirmButtonColor: COLORS.orange,
//             });

//             return true;
//         }

//         if (errorCode === "TEACHER_NOT_ASSIGNED") {
//             Swal.fire({
//                 icon: "warning",
//                 title: "Teacher Not Assigned",
//                 html: `
//                     <div style="text-align:center;">
//                         <p style="font-size:16px;line-height:1.6;">
//                             Your teacher account is not currently
//                             assigned to an active academic year.
//                         </p>

//                         <p style="
//                             font-size:17px;
//                             font-weight:800;
//                             color:${COLORS.oceanBlue};
//                         ">
//                             ${academicYear}
//                         </p>

//                         <p style="color:#6B7280;line-height:1.6;">
//                             Please contact the school administration
//                             to have your teacher record assigned.
//                         </p>
//                     </div>
//                 `,
//                 confirmButtonText: "Understood",
//                 confirmButtonColor: COLORS.orange,
//             });

//             return true;
//         }

//         if (errorCode === "NO_ACTIVE_ACADEMIC_YEAR") {
//             Swal.fire({
//                 icon: "warning",
//                 title: "No Active Academic Year",
//                 text:
//                     "There is currently no active academic year. Please contact the school administration.",
//                 confirmButtonText: "Understood",
//                 confirmButtonColor: COLORS.orange,
//             });

//             return true;
//         }

//         if (
//             errorCode === "EMPLOYMENT_LOGIN_BLOCKED" ||
//             errorCode === "LOGIN_BLOCKED"
//         ) {
//             Swal.fire({
//                 icon: "warning",
//                 title: "Login Blocked",
//                 html: `
//                     <div style="text-align:center;">
//                         <p style="font-size:16px;line-height:1.6;">
//                             Your account is currently blocked from
//                             accessing the school management system.
//                         </p>

//                         <p style="
//                             color:#374151;
//                             font-weight:600;
//                             line-height:1.6;
//                         ">
//                             Please contact an authorized school
//                             administrator.
//                         </p>
//                     </div>
//                 `,
//                 confirmButtonText: "Understood",
//                 confirmButtonColor: COLORS.orange,
//             });

//             return true;
//         }

//         return false;
//     };

//     const handleBlockedResponse = (data) => {
//         if (!data) {
//             return false;
//         }

//         const status = String(
//             data?.employment_status || ""
//         )
//             .toLowerCase()
//             .trim();

//         const errorCode = String(
//             data?.error_code || ""
//         )
//             .toUpperCase()
//             .trim();

//         const employmentCodes = [
//             "TEACHER_REMOVED",
//             "TEACHER_FIRED",
//             "EMPLOYMENT_REMOVED",
//             "EMPLOYMENT_FIRED",
//             "EMPLOYMENT_LOGIN_BLOCKED",
//             "LOGIN_BLOCKED",
//             "TEACHER_NOT_ASSIGNED",
//             "NO_ACTIVE_ACADEMIC_YEAR",
//         ];

//         const isEmploymentError =
//             employmentCodes.includes(errorCode) ||
//             ["removed", "fired"].includes(status);

//         if (!isEmploymentError) {
//             return false;
//         }

//         clearAuthenticationData();
//         return showEmploymentStatusAlert(data);
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         const cleanEmail = email.trim();

//         if (!cleanEmail || !password) {
//             Swal.fire({
//                 icon: "warning",
//                 title: "Missing Information",
//                 text:
//                     "Please enter your email address and password.",
//                 confirmButtonColor: COLORS.orange,
//             });

//             return;
//         }

//         setLoading(true);

//         try {
//             clearAuthenticationData();

//             const response = await api.post(
//                 "/api/token/",
//                 {
//                     email: cleanEmail,
//                     password,
//                 }
//             );

//             console.log(
//                 "TOKEN RESPONSE:",
//                 response.data
//             );

//             if (
//                 handleBlockedResponse(
//                     response.data
//                 )
//             ) {
//                 return;
//             }

//             const role = String(
//                 response.data?.user_type ||
//                 response.data?.user?.role ||
//                 ""
//             )
//                 .toLowerCase()
//                 .trim();

//             const authenticationRoles = [
//                 "admin",
//                 "registry",
//                 "principal",
//                 "proprietor",
//                 "business_manager",
//                 "business manager",
//                 "vpi",
//                 "vpa",
//                 "it personel",
//                 "it personnel",
//             ];

//             if (
//                 response.data?.requires_authentication &&
//                 authenticationRoles.includes(role)
//             ) {
//                 const authEmail =
//                     response.data?.email ||
//                     response.data?.user?.email ||
//                     cleanEmail;

//                 localStorage.setItem(
//                     "auth_email",
//                     authEmail
//                 );

//                 navigate(
//                     "/loginAuthentication",
//                     {
//                         state: {
//                             email: authEmail,
//                         },
//                     }
//                 );

//                 return;
//             }

//             const access =
//                 response.data?.access;

//             const refresh =
//                 response.data?.refresh;

//             if (!access || !refresh) {
//                 throw new Error(
//                     "Authentication tokens were not returned."
//                 );
//             }

//             localStorage.setItem(
//                 "access",
//                 access
//             );

//             localStorage.setItem(
//                 "refresh",
//                 refresh
//             );

//             if (
//                 response.data?.employment_status
//             ) {
//                 localStorage.setItem(
//                     "employment_status",
//                     response.data.employment_status
//                 );
//             }

//             if (
//                 response.data
//                     ?.employment_status_display
//             ) {
//                 localStorage.setItem(
//                     "employment_status_display",
//                     response.data
//                         .employment_status_display
//                 );
//             }

//             if (
//                 response.data?.academic_year
//             ) {
//                 localStorage.setItem(
//                     "employment_academic_year",
//                     response.data.academic_year
//                 );
//             }

//             window.dispatchEvent(
//                 new Event("user-logged-in")
//             );

//             let profileResponse;

//             try {
//                 profileResponse =
//                     await api.get(
//                         "/api/user-profile/"
//                     );
//             } catch (profileError) {
//                 clearAuthenticationData();
//                 throw profileError;
//             }

//             const user =
//                 profileResponse.data;

//             const frontendStatus = String(
//                 response.data
//                     ?.employment_status ||
//                 user?.employment_status ||
//                 ""
//             )
//                 .toLowerCase()
//                 .trim();

//             if (
//                 frontendStatus === "removed" ||
//                 frontendStatus === "fired"
//             ) {
//                 clearAuthenticationData();

//                 showEmploymentStatusAlert({
//                     error_code:
//                         frontendStatus === "removed"
//                             ? "TEACHER_REMOVED"
//                             : "TEACHER_FIRED",
//                     employment_status:
//                         frontendStatus,
//                     employment_status_display:
//                         frontendStatus === "removed"
//                             ? "REMOVED"
//                             : "SACKED / FIRED",
//                     academic_year:
//                         response.data?.academic_year ||
//                         response.data
//                             ?.academic_year_name,
//                 });

//                 return;
//             }

//             setUser(user);

//             localStorage.setItem(
//                 "user",
//                 JSON.stringify(user)
//             );

//             Swal.fire({
//                 icon: "success",
//                 title: "Welcome Back!",
//                 text: `Welcome ${
//                     user?.user_type ||
//                     user?.role ||
//                     ""
//                 }`,
//                 timer: 1800,
//                 showConfirmButton: false,
//                 background: COLORS.white,
//                 color: COLORS.black,
//                 iconColor: COLORS.orange,
//             });

//             setTimeout(() => {
//                 redirectUser(user);
//             }, 1700);
//         } catch (error) {
//             console.error(
//                 "LOGIN ERROR:",
//                 error
//             );

//             const responseData =
//                 error?.response?.data;

//             if (responseData) {
//                 const handled =
//                     handleBlockedResponse(
//                         responseData
//                     );

//                 if (handled) {
//                     return;
//                 }
//             }

//             Swal.fire({
//                 icon: "error",
//                 title: "Login Failed",
//                 text: getLoginError(error),
//                 confirmButtonText: "Try Again",
//                 confirmButtonColor: COLORS.orange,
//                 background: COLORS.white,
//                 color: COLORS.black,
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <Box
//             sx={{
//                 width: "100%",
//                 minHeight: "100dvh",
//                 overflow: "hidden",
//                 background: COLORS.skyBlue,
//             }}
//         >
//             <Box
//                 sx={{
//                     width: "100%",
//                     minHeight: "100dvh",
//                     display: "flex",
//                     flexDirection: {
//                         xs: "column",
//                         md: "row",
//                     },
//                 }}
//             >
//                 {/* DESKTOP LEFT PANEL */}
//                 <Box
//                     sx={{
//                         display: {
//                             xs: "none",
//                             md: "flex",
//                         },
//                         position: "relative",
//                         width: "53%",
//                         height: "100dvh",
//                         flexDirection: "column",
//                         overflow: "hidden",
//                         color: COLORS.white,
//                         background:
//                              "linear-gradient(145deg, #020617 0%, #010b22 38%, #011328 72%, #001f30 100%)",
//                             // "linear-gradient(145deg, #020617 0%, #031B4E 38%, #063B78 72%, #075985 100%)",
//                     }}
//                 >
//                     <motion.div
//                         animate={{
//                             scale: [1, 1.2, 1],
//                             opacity: [0.12, 0.3, 0.12],
//                         }}
//                         transition={{
//                             duration: 8,
//                             repeat: Infinity,
//                             ease: "easeInOut",
//                         }}
//                         style={{
//                             position: "absolute",
//                             width: 650,
//                             height: 650,
//                             borderRadius: "50%",
//                             top: -360,
//                             left: -320,
//                             background:
//                                 "radial-gradient(circle, rgba(8,126,164,.55), transparent 68%)",
//                         }}
//                     />

//                     <motion.div
//                         animate={{
//                             scale: [1, 1.22, 1],
//                             opacity: [0.1, 0.25, 0.1],
//                         }}
//                         transition={{
//                             duration: 9,
//                             repeat: Infinity,
//                             ease: "easeInOut",
//                         }}
//                         style={{
//                             position: "absolute",
//                             width: 600,
//                             height: 600,
//                             borderRadius: "50%",
//                             right: -320,
//                             bottom: -320,
//                             background:
//                                 "radial-gradient(circle, rgba(249,115,22,.3), transparent 68%)",
//                         }}
//                     />

//                     <Box
//                         sx={{
//                             position: "relative",
//                             zIndex: 20,
//                             textAlign: "center",
//                             pt: 5,
//                             px: 4,
//                         }}
//                     >
// <Box
//     sx={{
//         display: "inline-flex",
//         alignItems: "center",
//         gap: 1.5,
//         px: 2.2,
//         py: 1,
//         borderRadius: "50px",
//         background: "rgba(255,255,255,.08)",
//         border: "1px solid rgba(255,255,255,.2)",
//         backdropFilter: "blur(12px)",
//     }}
// >
//     <School
//         sx={{
//             fontSize: 24,
//             color: COLORS.white,
//         }}
//     />

//     <Typography
//         sx={{
//             fontSize: ".72rem",
//             fontWeight: 900,
//             letterSpacing: 1.5,
//             color: COLORS.white,
//         }}
//     >
//         <Box
//             component="span"
//             sx={{
//                 color: "#D35400",
//                 fontWeight: 1000,
//             }}
//         >
//             POLU
//         </Box>{" "}
//         SCHOOL MANAGEMENT PORTAL
//     </Typography>
// </Box>

//                         <Typography
//                             sx={{
//                                 mt: 2.5,
//                                 fontSize: {
//                                     md: "1.65rem",
//                                     lg: "2rem",
//                                 },
//                                 fontWeight: 950,
//                                 letterSpacing: 1.5,
//                                 lineHeight: 1.15,
//                                 textTransform: "uppercase",
//                             }}
//                         >
//                             Salvation In Christ
//                         </Typography>

//                         <Typography
//                             sx={{
//                                 mt: 0.7,
//                                 color: "#BDEEFF",
//                                 fontSize: {
//                                     md: ".9rem",
//                                     lg: "1rem",
//                                 },
//                                 fontWeight: 800,
//                                 letterSpacing: 2,
//                             }}
//                         >
//                             SCHOOL SYSTEM
//                         </Typography>

//                         <Box
//                             sx={{
//                                 width: 90,
//                                 height: 4,
//                                 borderRadius: 20,
//                                 mx: "auto",
//                                 mt: 2,
//                                 background:
//                                     "linear-gradient(90deg, #FFFFFF, #F97316)",
//                             }}
//                         />
//                     </Box>

//                     {/* STUDENT ENERGY AREA */}
//                     <Box
//                         sx={{
//                             position: "relative",
//                             flex: 1,
//                             minHeight: 0,
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                         }}
//                     >
//                         {/* Clearly moving orbital energy */}
//                         <OrbitEnergy
//                             size={500}
//                             duration={17}
//                             color="rgba(255,255,255,.25)"
//                             secondaryColor={COLORS.orange}
//                         />

//                         <OrbitEnergy
//                             size={420}
//                             duration={11}
//                             reverse
//                             color="rgba(8,126,164,.75)"
//                             secondaryColor="#FFFFFF"
//                             dashed
//                         />

//                         <OrbitEnergy
//                             size={350}
//                             duration={8}
//                             color="rgba(249,115,22,.8)"
//                             secondaryColor="#FFFFFF"
//                         />

//                         <OrbitEnergy
//                             size={280}
//                             duration={6}
//                             reverse
//                             color="rgba(255,255,255,.3)"
//                             secondaryColor={COLORS.orange}
//                             dashed
//                         />

//                         {/* Additional moving particles */}
//                         <EnergyParticle
//                             top="24%"
//                             left="27%"
//                             size={9}
//                             delay={0}
//                         />

//                         <EnergyParticle
//                             top="31%"
//                             right="26%"
//                             size={7}
//                             delay={0.7}
//                             color={COLORS.orange}
//                         />

//                         <EnergyParticle
//                             top="43%"
//                             left="16%"
//                             size={6}
//                             delay={1.3}
//                         />

//                         <EnergyParticle
//                             top="49%"
//                             right="16%"
//                             size={9}
//                             delay={1.9}
//                         />

//                         <EnergyParticle
//                             top="60%"
//                             left="24%"
//                             size={7}
//                             delay={2.5}
//                             color={COLORS.orange}
//                         />

//                         <EnergyParticle
//                             top="57%"
//                             right="23%"
//                             size={6}
//                             delay={3}
//                         />

//                         {/* Moving speed streaks */}
//                         <SpeedLine
//                             top="28%"
//                             left="8%"
//                             width={170}
//                             rotate={-22}
//                             delay={0}
//                         />

//                         <SpeedLine
//                             top="34%"
//                             left="4%"
//                             width={110}
//                             rotate={-19}
//                             delay={0.6}
//                             color={COLORS.orange}
//                         />

//                         <SpeedLine
//                             top="42%"
//                             right="5%"
//                             width={155}
//                             rotate={-26}
//                             delay={1.1}
//                         />

//                         <SpeedLine
//                             top="49%"
//                             right="8%"
//                             width={100}
//                             rotate={-24}
//                             delay={1.7}
//                             color={COLORS.orange}
//                         />

//                         <SpeedLine
//                             top="60%"
//                             left="9%"
//                             width={125}
//                             rotate={-16}
//                             delay={2.1}
//                         />

//                         <SpeedLine
//                             top="64%"
//                             right="10%"
//                             width={130}
//                             rotate={-20}
//                             delay={2.5}
//                         />

//                         {/* Static glow behind student */}
//                         <Box
//                             sx={{
//                                 position: "absolute",
//                                 width: 420,
//                                 height: 420,
//                                 borderRadius: "50%",
//                                 background:
//                                     "radial-gradient(circle, rgba(8,126,164,.3), rgba(3,27,78,.05) 55%, transparent 72%)",
//                                 zIndex: 4,
//                             }}
//                         />

//                         {/* STATIC STUDENT - NO MOTION */}
//                         <Box
//                             component="img"
//                             src={student}
//                             alt="Excited student"
//                             sx={{
//                                 position: "relative",
//                                 zIndex: 20,
//                                 width: {
//                                     md: "74%",
//                                     lg: "78%",
//                                 },
//                                 maxWidth: 700,
//                                 height: "82%",
//                                 objectFit: "contain",
//                                 objectPosition: "center bottom",
//                                 filter:
//                                     "drop-shadow(0 30px 35px rgba(0,0,0,.45))",
//                                 userSelect: "none",
//                                 pointerEvents: "none",
//                             }}
//                         />

//                         <motion.div
//                             animate={{
//                                 scale: [0.8, 1.2, 0.8],
//                                 rotate: [-10, 8, -10],
//                                 opacity: [0.4, 1, 0.4],
//                             }}
//                             transition={{
//                                 duration: 2.2,
//                                 repeat: Infinity,
//                             }}
//                             style={{
//                                 position: "absolute",
//                                 right: "20%",
//                                 top: "28%",
//                                 zIndex: 25,
//                             }}
//                         >
//                             <Bolt
//                                 sx={{
//                                     fontSize: 42,
//                                     color: COLORS.white,
//                                     filter:
//                                         "drop-shadow(0 0 14px rgba(255,255,255,.8))",
//                                 }}
//                             />
//                         </motion.div>

//                         <motion.div
//                             animate={{
//                                 scale: [0.7, 1.3, 0.7],
//                                 rotate: [0, 180, 360],
//                                 opacity: [0.35, 1, 0.35],
//                             }}
//                             transition={{
//                                 duration: 4,
//                                 repeat: Infinity,
//                                 ease: "easeInOut",
//                             }}
//                             style={{
//                                 position: "absolute",
//                                 left: "20%",
//                                 top: "38%",
//                                 zIndex: 25,
//                             }}
//                         >
//                             <AutoAwesome
//                                 sx={{
//                                     fontSize: 34,
//                                     color: COLORS.orange,
//                                 }}
//                             />
//                         </motion.div>
//                     </Box>

//                     <Box
//                         sx={{
//                             position: "relative",
//                             zIndex: 20,
//                             textAlign: "center",
//                             pb: 3,
//                         }}
//                     >
//                         <Typography
//                             sx={{
//                                 color:
//                                     "rgba(255,255,255,.7)",
//                                 fontSize: ".68rem",
//                                 fontWeight: 800,
//                                 letterSpacing: 1.4,
//                             }}
//                         >
//                             LEARNING • CHARACTER • EXCELLENCE
//                         </Typography>
//                     </Box>
//                 </Box>

//                 {/* MOBILE BRAND */}
//                 <Box
//                     sx={{
//                         display: {
//                             xs: "flex",
//                             md: "none",
//                         },
//                         position: "fixed",
//                         top: 0,
//                         left: 0,
//                         right: 0,
//                         zIndex: 30,
//                         justifyContent: "center",
//                         pt: 2,
//                         pointerEvents: "none",
//                     }}
//                 >
//                     <Box
//                         sx={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 1,
//                             px: 2,
//                             py: 0.9,
//                             borderRadius: "50px",
//                             background:
//                                 "rgba(255,255,255,.94)",
//                             border:
//                                 `1px solid ${COLORS.border}`,
//                             boxShadow:
//                                 "0 8px 25px rgba(4,90,120,.1)",
//                         }}
//                     >
//                         <School
//                             sx={{
//                                 fontSize: 21,
//                                 color: COLORS.oceanBlue,
//                             }}
//                         />

//                         <Typography
//                             sx={{
//                                 fontSize: ".68rem",
//                                 fontWeight: 900,
//                                 color: COLORS.deepOcean,
//                                 letterSpacing: 0.7,
//                             }}
//                         >
//                             SALVATION IN CHRIST
//                         </Typography>
//                     </Box>
//                 </Box>

//                 {/* LOGIN AREA */}
//                 <Box
//                     sx={{
//                         position: "relative",
//                         width: {
//                             xs: "100%",
//                             md: "47%",
//                         },
//                         minHeight: "100dvh",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         boxSizing: "border-box",
//                         overflowY: "auto",
//                         overflowX: "hidden",
//                         px: {
//                             xs: 1.5,
//                             sm: 3,
//                             md: 5,
//                         },
//                         py: {
//                             xs: 6,
//                             sm: 5,
//                             md: 4,
//                         },
//                         background:
//                             "linear-gradient(135deg, #FFFFFF 0%, #F3FBFE 55%, #E4F7FF 100%)",
//                     }}
//                 >
//                     {/* BACKGROUND DECORATION */}
//                     <motion.div
//                         animate={{
//                             scale: [1, 1.2, 1],
//                             opacity: [0.12, 0.23, 0.12],
//                         }}
//                         transition={{
//                             duration: 7,
//                             repeat: Infinity,
//                             ease: "easeInOut",
//                         }}
//                         style={{
//                             position: "absolute",
//                             width: 400,
//                             height: 400,
//                             borderRadius: "50%",
//                             background:
//                                 "radial-gradient(circle, rgba(8,126,164,.25), transparent 68%)",
//                             top: -230,
//                             right: -210,
//                         }}
//                     />

//                     <motion.div
//                         animate={{
//                             scale: [0.9, 1.15, 0.9],
//                             opacity: [0.08, 0.2, 0.08],
//                         }}
//                         transition={{
//                             duration: 8,
//                             repeat: Infinity,
//                             ease: "easeInOut",
//                         }}
//                         style={{
//                             position: "absolute",
//                             width: 350,
//                             height: 350,
//                             borderRadius: "50%",
//                             background:
//                                 "radial-gradient(circle, rgba(249,115,22,.2), transparent 68%)",
//                             bottom: -200,
//                             left: -200,
//                         }}
//                     />

//                     {/* LOGIN CARD */}
//                     <Box
//                         sx={{
//                             position: "relative",
//                             zIndex: 10,
//                             width: "100%",
//                             maxWidth: 460,
//                             mx: "auto",
//                         }}
//                     >
//                         <motion.div
//                             initial={{
//                                 opacity: 0,
//                                 y: 25,
//                             }}
//                             animate={{
//                                 opacity: 1,
//                                 y: 0,
//                             }}
//                             transition={{
//                                 duration: 0.65,
//                                 ease: "easeOut",
//                             }}
//                         >
//                             <Paper
//                                 elevation={0}
//                                 sx={{
//                                     position: "relative",
//                                     width: "100%",
//                                     boxSizing: "border-box",
//                                     overflow: "hidden",
//                                     p: {
//                                         xs: 2.4,
//                                         sm: 3.5,
//                                         md: 4,
//                                     },
//                                     borderRadius: {
//                                         xs: "20px",
//                                         sm: "26px",
//                                         md: "30px",
//                                     },
//                                     background:
//                                         "rgba(255,255,255,.98)",
//                                     border:
//                                         `1px solid ${COLORS.border}`,
//                                     boxShadow:
//                                         "0 25px 65px rgba(4,90,120,.14)",
//                                 }}
//                             >
//                                 <Box
//                                     sx={{
//                                         position: "absolute",
//                                         top: 0,
//                                         left: 0,
//                                         right: 0,
//                                         height: 5,
//                                         background:
//                                             `linear-gradient(90deg, ${COLORS.deepBlue}, ${COLORS.oceanBlue}, ${COLORS.orange})`,
//                                     }}
//                                 />

//                                 {/* HEADER */}
//                                 <Box
//                                     sx={{
//                                         textAlign: "center",
//                                         mb: 3,
//                                     }}
//                                 >
//                                     {/* <Box
//                                         sx={{
//                                             width: 64,
//                                             height: 64,
//                                             mx: "auto",
//                                             borderRadius: "20px",
//                                             display: "flex",
//                                             alignItems: "center",
//                                             justifyContent: "center",
//                                             background:
//                                                 `linear-gradient(135deg, ${COLORS.deepBlue}, ${COLORS.oceanBlue})`,
//                                             boxShadow:
//                                                 "0 13px 30px rgba(4,90,120,.22)",
//                                             position: "relative",
//                                         }}
//                                     >
//                                         <Lock
//                                             sx={{
//                                                 fontSize: 30,
//                                                 color: COLORS.white,
//                                             }}
//                                         />

//                                         <Box
//                                             sx={{
//                                                 position: "absolute",
//                                                 width: 10,
//                                                 height: 10,
//                                                 borderRadius: "50%",
//                                                 background:
//                                                     COLORS.orange,
//                                                 right: -3,
//                                                 top: -3,
//                                                 border:
//                                                     `3px solid ${COLORS.white}`,
//                                             }}
//                                         />
//                                     </Box> */}
//                                     <Box
//     sx={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         gap: 1.25,
//         width: "100%",
//         whiteSpace: "nowrap",
//     }}
// >
//     <Box
//         sx={{
//             width: 56,
//             height: 56,
//             flexShrink: 0,
//             borderRadius: "17px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             background: `linear-gradient(
//                 135deg,
//                 ${COLORS.deepBlue},
//                 ${COLORS.oceanBlue}
//             )`,
//             boxShadow: "0 10px 25px rgba(0, 31, 91, 0.20)",
//             position: "relative",
//         }}
//     >
//         <Lock
//             sx={{
//                 fontSize: 27,
//                 color: COLORS.white,
//             }}
//         />

//         <Box
//             sx={{
//                 position: "absolute",
//                 width: 9,
//                 height: 9,
//                 borderRadius: "50%",
//                 background: "#e85d04",
//                 right: -2,
//                 top: -2,
//                 border: `3px solid ${COLORS.white}`,
//             }}
//         />
//     </Box>

//     <Typography
//         component="div"
//         sx={{
//             display: "flex",
//             alignItems: "baseline",
//             gap: 0.65,
//             whiteSpace: "nowrap",
//             fontFamily:
//                 '"Arial Black", "Montserrat", "Segoe UI", sans-serif',
//             fontWeight: 900,
//             letterSpacing: "-0.25px",
//             fontSize: {
//                 xs: "0.78rem",
//                 sm: "0.95rem",
//                 md: "1.02rem",
//             },
//         }}
//     >
//         <Box
//             component="span"
//             sx={{
//                 color: "#e85d04",
//                 fontWeight: 950,
//                 letterSpacing: "0.2px",
//             }}
//         >
//             POLU
//         </Box>

//         <Box
//             component="span"
//             sx={{
//                 color: COLORS.black,
//                 fontWeight: 800,
//                 letterSpacing: "0.35px",
//             }}
//         >
//             SCHOOL MANAGEMENT
//         </Box>
//     </Typography>
// </Box>

//                                     <Typography
//                                         sx={{
//                                             mt: 2,
//                                             fontSize: {
//                                                 xs: "1.55rem",
//                                                 sm: "1.85rem",
//                                             },
//                                             fontWeight: 950,
//                                             color: COLORS.text,
//                                         }}
//                                     >
//                                         Welcome Back
//                                     </Typography>

//                                     <Typography
//                                         sx={{
//                                             color: COLORS.muted,
//                                             mt: 0.8,
//                                             lineHeight: 1.65,
//                                             fontSize: ".87rem",
//                                         }}
//                                     >
//                                         Sign in to securely access your
//                                         <br />

//                                         <strong
//                                             style={{
//                                                 color:
//                                                     COLORS.oceanBlue,
//                                             }}
//                                         >
//                                             Salvation In Christ School System
//                                         </strong>
//                                     </Typography>
//                                 </Box>

//                                 {/* SECURITY BADGE */}
//                                 <Box
//                                     sx={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         justifyContent: "center",
//                                         gap: 0.8,
//                                         mb: 2.5,
//                                         py: 0.9,
//                                         px: 1.5,
//                                         borderRadius: "50px",
//                                         background:
//                                             COLORS.softBlue,
//                                         border:
//                                             "1px solid rgba(8,126,164,.13)",
//                                     }}
//                                 >
//                                     <Security
//                                         sx={{
//                                             fontSize: 16,
//                                             color:
//                                                 COLORS.oceanBlue,
//                                         }}
//                                     />

//                                     <Typography
//                                         sx={{
//                                             fontSize: ".62rem",
//                                             fontWeight: 900,
//                                             color:
//                                                 COLORS.deepOcean,
//                                             letterSpacing: 0.6,
//                                             textAlign: "center",
//                                         }}
//                                     >
//                                         SECURE SCHOOL MANAGEMENT PORTAL
//                                     </Typography>
//                                 </Box>

//                                 {/* FORM */}
//                                 <form onSubmit={handleSubmit}>
//                                     <TextField
//                                         fullWidth
//                                         label="Email Address"
//                                         variant="outlined"
//                                         value={email}
//                                         onChange={(e) =>
//                                             setEmail(
//                                                 e.target.value
//                                             )
//                                         }
//                                         required
//                                         autoComplete="email"
//                                         InputProps={{
//                                             startAdornment: (
//                                                 <InputAdornment position="start">
//                                                     <Email
//                                                         sx={{
//                                                             color:
//                                                                 COLORS.oceanBlue,
//                                                         }}
//                                                     />
//                                                 </InputAdornment>
//                                             ),
//                                         }}
//                                         sx={{
//                                             mb: 2,
//                                             "& .MuiOutlinedInput-root": {
//                                                 borderRadius: "14px",
//                                                 background: "#F8FCFE",
//                                                 "& fieldset": {
//                                                     borderColor:
//                                                         COLORS.border,
//                                                 },
//                                                 "&:hover fieldset": {
//                                                     borderColor:
//                                                         "#83CFE7",
//                                                 },
//                                                 "&.Mui-focused fieldset": {
//                                                     borderColor:
//                                                         COLORS.oceanBlue,
//                                                     borderWidth: 2,
//                                                 },
//                                             },
//                                             "& .MuiInputLabel-root.Mui-focused":
//                                                 {
//                                                     color:
//                                                         COLORS.oceanBlue,
//                                                 },
//                                         }}
//                                     />

//                                     <TextField
//                                         fullWidth
//                                         label="Password"
//                                         type={
//                                             showPassword
//                                                 ? "text"
//                                                 : "password"
//                                         }
//                                         variant="outlined"
//                                         value={password}
//                                         onChange={(e) =>
//                                             setPassword(
//                                                 e.target.value
//                                             )
//                                         }
//                                         required
//                                         autoComplete="current-password"
//                                         InputProps={{
//                                             startAdornment: (
//                                                 <InputAdornment position="start">
//                                                     <Lock
//                                                         sx={{
//                                                             color:
//                                                                 COLORS.oceanBlue,
//                                                         }}
//                                                     />
//                                                 </InputAdornment>
//                                             ),
//                                             endAdornment: (
//                                                 <InputAdornment position="end">
//                                                     <IconButton
//                                                         onClick={() =>
//                                                             setShowPassword(
//                                                                 (prev) =>
//                                                                     !prev
//                                                             )
//                                                         }
//                                                         edge="end"
//                                                         aria-label={
//                                                             showPassword
//                                                                 ? "Hide password"
//                                                                 : "Show password"
//                                                         }
//                                                     >
//                                                         {showPassword ? (
//                                                             <VisibilityOff
//                                                                 sx={{
//                                                                     color:
//                                                                         COLORS.muted,
//                                                                 }}
//                                                             />
//                                                         ) : (
//                                                             <Visibility
//                                                                 sx={{
//                                                                     color:
//                                                                         COLORS.muted,
//                                                                 }}
//                                                             />
//                                                         )}
//                                                     </IconButton>
//                                                 </InputAdornment>
//                                             ),
//                                         }}
//                                         sx={{
//                                             "& .MuiOutlinedInput-root": {
//                                                 borderRadius: "14px",
//                                                 background: "#F8FCFE",
//                                                 "& fieldset": {
//                                                     borderColor:
//                                                         COLORS.border,
//                                                 },
//                                                 "&:hover fieldset": {
//                                                     borderColor:
//                                                         "#83CFE7",
//                                                 },
//                                                 "&.Mui-focused fieldset": {
//                                                     borderColor:
//                                                         COLORS.oceanBlue,
//                                                     borderWidth: 2,
//                                                 },
//                                             },
//                                             "& .MuiInputLabel-root.Mui-focused":
//                                                 {
//                                                     color:
//                                                         COLORS.oceanBlue,
//                                                 },
//                                         }}
//                                     />

//                                     <Box
//                                         sx={{
//                                             display: "flex",
//                                             justifyContent:
//                                                 "flex-end",
//                                             mt: 1.3,
//                                             mb: 2.7,
//                                         }}
//                                     >
//                                         <Link
//                                             to="/forgotPassword"
//                                             style={{
//                                                 color:
//                                                     COLORS.deepOrange,
//                                                 fontWeight: 850,
//                                                 textDecoration:
//                                                     "none",
//                                                 fontSize: ".84rem",
//                                             }}
//                                         >
//                                             Forgot Password?
//                                         </Link>
//                                     </Box>

//                                     <Button
//                                         type="submit"
//                                         fullWidth
//                                         disabled={loading}
//                                         variant="contained"
//                                         sx={{
//                                             py: 1.55,
//                                             borderRadius: "14px",
//                                             fontSize: ".97rem",
//                                             fontWeight: 900,
//                                             textTransform: "none",
//                                             color: COLORS.white,
//                                             background:
//                                                 `linear-gradient(135deg, ${COLORS.deepBlue}, ${COLORS.oceanBlue})`,
//                                             boxShadow:
//                                                 "0 14px 30px rgba(4,90,120,.22)",
//                                             transition:
//                                                 "all .25s ease",
//                                             "&:hover": {
//                                                 background:
//                                                     `linear-gradient(135deg, ${COLORS.deepOrange}, ${COLORS.orange})`,
//                                                 boxShadow:
//                                                     "0 16px 35px rgba(249,115,22,.28)",
//                                                 transform:
//                                                     "translateY(-2px)",
//                                             },
//                                             "&:disabled": {
//                                                 background:
//                                                     "#9DB4BE",
//                                             },
//                                         }}
//                                     >
//                                         {loading ? (
//                                             <Box
//                                                 sx={{
//                                                     display: "flex",
//                                                     alignItems:
//                                                         "center",
//                                                     justifyContent:
//                                                         "center",
//                                                     gap: 1.3,
//                                                 }}
//                                             >
//                                                 <CircularProgress
//                                                     size={21}
//                                                     thickness={5}
//                                                     sx={{
//                                                         color:
//                                                             COLORS.white,
//                                                     }}
//                                                 />
//                                                 Signing In...
//                                             </Box>
//                                         ) : (
//                                             <Box
//                                                 sx={{
//                                                     display: "flex",
//                                                     alignItems:
//                                                         "center",
//                                                     justifyContent:
//                                                         "center",
//                                                     gap: 0.9,
//                                                 }}
//                                             >
//                                                 <AutoAwesome
//                                                     sx={{
//                                                         fontSize: 18,
//                                                     }}
//                                                 />
//                                                 Sign In Securely
//                                             </Box>
//                                         )}
//                                     </Button>

//                                     <Button
//                                         fullWidth
//                                         variant="outlined"
//                                         onClick={() =>
//                                             navigate("/")
//                                         }
//                                         startIcon={
//                                             <ArrowBack />
//                                         }
//                                         sx={{
//                                             mt: 1.5,
//                                             py: 1.35,
//                                             borderRadius: "14px",
//                                             fontSize: ".9rem",
//                                             fontWeight: 800,
//                                             textTransform: "none",
//                                             color:
//                                                 COLORS.deepOcean,
//                                             border:
//                                                 `1.5px solid ${COLORS.border}`,
//                                             "&:hover": {
//                                                 background:
//                                                     COLORS.softBlue,
//                                                 borderColor:
//                                                     COLORS.oceanBlue,
//                                                 color:
//                                                     COLORS.deepOcean,
//                                             },
//                                         }}
//                                     >
//                                         Back to Home
//                                     </Button>
//                                 </form>

//                                 {/* FOOTER */}
//                                 <Box
//                                     sx={{
//                                         mt: 3,
//                                         pt: 2.2,
//                                         borderTop:
//                                             `1px solid ${COLORS.border}`,
//                                         textAlign: "center",
//                                     }}
//                                 >
//                                     <Box
//                                         sx={{
//                                             display: "flex",
//                                             alignItems:
//                                                 "center",
//                                             justifyContent:
//                                                 "center",
//                                             gap: 0.7,
//                                             mb: 0.6,
//                                         }}
//                                     >
//                                         <VerifiedUser
//                                             sx={{
//                                                 fontSize: 14,
//                                                 color:
//                                                     COLORS.oceanBlue,
//                                             }}
//                                         />

//                                         <Typography
//                                             sx={{
//                                                 fontSize: ".66rem",
//                                                 fontWeight: 850,
//                                                 color:
//                                                     COLORS.oceanBlue,
//                                                 letterSpacing: 0.5,
//                                             }}
//                                         >
//                                             SECURE AUTHENTICATION
//                                         </Typography>
//                                     </Box>

//                                     <Typography
//                                         sx={{
//                                             fontSize: ".68rem",
//                                             color: "#8AA0AA",
//                                             lineHeight: 1.6,
//                                         }}
//                                     >
//                                         Your credentials are protected
//                                         <br />
//                                         by secure authentication.
//                                     </Typography>
//                                 </Box>
//                             </Paper>
//                         </motion.div>
//                     </Box>
//                 </Box>
//             </Box>
//         </Box>
//     );
// };

// export default Login;